import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {MaterialModule} from './material.module';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {NgxMasonryModule} from 'ngx-masonry';
import {library} from '@fortawesome/fontawesome-svg-core';
import {MomentModule} from 'ngx-moment';


import {
    faAsterisk,
    faBars,
    faUserCircle,
    faPowerOff,
    faCog,
    faPlayCircle,
    faRocket,
    faPlus,
    faEdit,
    faTrash,
    faTimes,
    faCaretUp,
    faCaretDown,
    faExclamationTriangle,
    faFilter,
    faTasks,
    faCheck,
    faSquare,
    faLanguage,
    faPaintBrush,
    faLightbulb,
    faWindowMaximize,
    faStream,
    faBook
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faAsterisk,
    faBars,
    faUserCircle,
    faPowerOff,
    faCog,
    faRocket,
    faPlayCircle,
    faPlus,
    faEdit,
    faTrash,
    faTimes,
    faCaretUp,
    faCaretDown,
    faExclamationTriangle,
    faFilter,
    faTasks,
    faCheck,
    faSquare,
    faLanguage,
    faPaintBrush,
    faLightbulb,
    faWindowMaximize,
    faStream,
    faBook
);


import {ControlMessagesComponent} from './components/control-messages/control-messages.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {TranslateModule} from '@ngx-translate/core';
import {RoomDetailsComponent} from "@app/shared/components/modals/room-details/room-details.component";
import {SlidePanelComponent} from './components/slide-panel/slide-panel.component';
import {DetailsPriceComponent} from './components/details-price/details-price.component';
import {ResaInfoComponent} from './components/resa-info/resa-info.component';
import {ModePaiementComponent} from './components/mode-paiement/mode-paiement.component';
import {PaypalFormComponent} from './components/payment-forms/paypal-form/paypal-form.component';
import {PciFormComponent} from './components/payment-forms/pci-form/pci-form.component';
import {StripeFormComponent} from './components/payment-forms/stripe-form/stripe-form.component';
import {ReglementComponent} from './components/reglement/reglement.component';
import {CommentsComponent} from '../shared/components/comments/comments.component';
import {TruncateTextPipe} from '../shared/pipes/truncate-text.pipe';
import {SanitizedHtmlPipe} from '../shared/pipes/sanitized-html.pipe';
import {RemovewhitespacesPipe} from '../shared/pipes/remove-espaces.pipe';
import {AlertModule} from './_alert/alert.module';
import {SnapshatComponent} from '../shared/components/modals/snapshat/snapshat.component';
import {FineprintComponent} from '../shared/components/modals/fineprint/fineprint.component';
import {AngularStickyThingsModule} from '@w11k/angular-sticky-things';
import {CardComponent} from './components/card/card.component';
import {NguCarouselModule} from '@ngu/carousel';
import {OffertComponent} from './components/offert/offert.component';
import {VoucherComponent} from '../shared/components/voucher/voucher.component';
import { PaymentTypesListComponent } from './components/mode-paiement/components/payment-types-list/payment-types-list.component';
import { ConfirmationMessageComponent } from './components/mode-paiement/components/confirmation-message/confirmation-message.component';
import { PayZoneFormComponent } from './components/payment-forms/pay-zone-form/pay-zone-form.component';
import { ExtrablockComponent } from './components/extrablock/extrablock.component';
import { PayExpressFormComponent } from '../shared/components/payment-forms/pay-express-form/pay-express-form.component';
import { OccupationComponent } from '../shared/components/occupation/occupation.component';
import { ConditionsComponent } from '../shared/components/conditions/conditions.component';
import { ServicesComponent } from '../shared/components/services/services.component';
import { SelectBedComponent } from '../shared/components/select-bed/select-bed.component';
import { SelectStockComponent } from '../shared/components/select-stock/select-stock.component';
import { CardFormComponent } from '../modules/checkprice/recap/components/payment-form/card-form/card-form.component'
import { FooterBookComponent } from '../shared/components/footer-book/footer-book.component';
import { SelectBedRoomComponent } from '../shared/components/select-bed-room/select-bed-room.component';
import { PriceMatchComponent } from '../shared/components/price-match/price-match.component';
import { PriceCheckComponent } from '../shared/components/price-check/price-check.component';
import { SurClassementComponent } from './components/modals/sur-classement/sur-classement.component';
import { LoadingComponent } from '../shared/components/loading/loading.component';
import { LoadingConnectedComponent } from '../shared/components/loading-connected/loading-connected.component';
import { FilterPipe } from './pipes/filter.pipe';
import { DuplicatedAddValuesPipe } from './pipes/duplicated-add-values.pipe';
import { AvailableDatesComponent } from './components/available-dates/available-dates.component';
import { PayOttuFormComponent } from '../shared/components/payment-forms/pay-ottu-form/pay-ottu-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        MaterialModule,
        AlertModule,

        NgbModule.forRoot(),
        FontAwesomeModule,
        MomentModule.forRoot({
            relativeTimeThresholdOptions: {
                'm': 59
            }
        }),
        AngularStickyThingsModule,
        NguCarouselModule
    ],
    declarations: [
        ControlMessagesComponent,
        SpinnerComponent,
        RoomDetailsComponent,
        SlidePanelComponent,
        DetailsPriceComponent,
        ResaInfoComponent,
        ModePaiementComponent,
        PaypalFormComponent,
        PciFormComponent,
        StripeFormComponent,
        ReglementComponent,
        CommentsComponent,
        TruncateTextPipe,
        SanitizedHtmlPipe,
        RemovewhitespacesPipe,
        DuplicatedAddValuesPipe,
        FilterPipe,
        SnapshatComponent,
        FineprintComponent,
        CardComponent,
        OffertComponent,
        VoucherComponent,
        CardFormComponent,
        PaymentTypesListComponent,
        ConfirmationMessageComponent,
        PayZoneFormComponent,
        ExtrablockComponent,
        PayExpressFormComponent,
        OccupationComponent,
        ConditionsComponent,
        ServicesComponent,
        SelectBedComponent,
        SelectStockComponent,
        FooterBookComponent,
        SelectBedRoomComponent,
        PriceMatchComponent,
        PriceCheckComponent,
        SurClassementComponent,
        LoadingComponent,
        LoadingConnectedComponent,
        AvailableDatesComponent,
        PayOttuFormComponent,
    ],
    exports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        MaterialModule,
        AlertModule,

        NgbModule,
        FontAwesomeModule,
        NgxMasonryModule,

        ControlMessagesComponent,
        SpinnerComponent,
        RoomDetailsComponent,
        SlidePanelComponent,
        DetailsPriceComponent,
        ResaInfoComponent,
        ModePaiementComponent,
        ConfirmationMessageComponent,
        PaypalFormComponent,
        PciFormComponent,
        StripeFormComponent,
        ReglementComponent,
        CommentsComponent,
        TruncateTextPipe,
        SanitizedHtmlPipe,
        RemovewhitespacesPipe,
        DuplicatedAddValuesPipe,
        FilterPipe,
        SnapshatComponent,
        FineprintComponent,
        CardComponent,
        OffertComponent,
        VoucherComponent,
        CardFormComponent,

        AngularStickyThingsModule,

        PayZoneFormComponent,
        ExtrablockComponent,
        PayExpressFormComponent,
        OccupationComponent,
        ConditionsComponent,
        ServicesComponent,
        SelectBedComponent,
        SelectStockComponent,
        FooterBookComponent,
        SelectBedRoomComponent,
        PriceMatchComponent,
        PriceCheckComponent,
        SurClassementComponent,
        LoadingComponent,
        LoadingConnectedComponent,
        AvailableDatesComponent,
    ],
    entryComponents: [RoomDetailsComponent, SnapshatComponent, SurClassementComponent, FineprintComponent, CardComponent, CardFormComponent, SelectBedRoomComponent]
})
export class SharedModule {}
